import React from 'react';
import { DEFAULT_PAGE_TITLE } from '../../constants';
import { getPagePresentationKeys } from '../../actions/page';
import StaticPage from './StaticPage';
import Layout from '../../components/Layout/Layout';

async function action({ store }, { pageName }) {
  const { byName } = await store.dispatch(
    getPagePresentationKeys({ pageName }),
  );
  const page = byName[pageName];
  if (!(page && page.pageBody)) {
    return undefined;
  }
  return {
    title: page.pageTitle || DEFAULT_PAGE_TITLE,
    description: page.pageDescription || '',
    chunks: ['page'],
    component: (
      <Layout footerBar>
        <StaticPage page={page} />
      </Layout>
    ),
    pageName,
    addCompanyMarkup: true,
  };
}

export default action;
